import App from "../App";

import joint from "rappid";
import _ from "lodash";
import graphlib from "graphlib";
import { Promise } from "ag-grid";

const ModuleMap = {
	"MoneySite": "Money Site",
	"SocialNetworkPremium": "Web 2.0 Blog\nPremium",
	"WebProfilePremium": "Web 2.0 Profile\nPremium",
	"BookmarkingPremium": "Bookmarking\nPremium",
	"PDFPremium": "PDF\nPremium",
	"ArticleDirectoryPremium": "Article Directory\nPremium",
	"SocialNetwork": "Web 2.0 Blog",
	"WebProfile": "Web 2.0 Profile",
	"Wiki": "Wiki",
	"ArticleDirectory": "Article Directory",
	"Bookmarking": "Bookmarking",
	"ForumProfile": "Forum Profile",
	"Private": "Private Blog",
	"PrivateBookmark": "Private Bookmark"
}

App.MainView = joint.mvc.View.extend({
	className: "app",

	events: {
		'focus input[type="range"]': "removeTargetFocus",
		mousedown: "removeFocus",
		touchstart: "removeFocus"
	},

	removeTargetFocus: function(evt) {
		evt.target.blur();
	},

	removeFocus: function() {
		document.activeElement.blur();
		window.getSelection().removeAllRanges();
	},

	init: function() {
		this.projectNumbersUsed = {};
		this.initializePaper();
		if (
			this.options.viewOnly == undefined ||
			this.options.viewOnly === false
		) {
			this.initializeStencil();
		}
		this.initializeSelection();
		if (!this.options.viewOnly) {
			this.initializeToolsAndInspector();
		}
		this.initializeNavigator();
		// this.initializeToolbar();
		this.initializeKeyboardShortcuts();
		this.initializeTooltips();
	},

	// Create a graph, paper and wrap the paper in a PaperScroller.
	initializePaper: function() {
		var graph = (this.graph = new joint.dia.Graph());

		graph.on(
			"add",
			function(cell, collection, opt) {
				if (!cell.get("type").startsWith("rankerx.")) {
					return;
				}
				let nameId = this.getFreeProjectNumber(cell.get("type"));

				cell.attr("custom/nameId", nameId);				
				// let headerText = cell.attr("headerText/text");
				let projectType = cell.get("type").substring(8);
				let headerText = ModuleMap[projectType] + ` (${nameId})`;
				// headerText = headerText + ` (${nameId})`;
				cell.attr("headerText/text", headerText);
				cell.attr("custom/projectName", headerText);
				let bbox = cell.getBBox();
				let height = bbox.height;
				let dim = joint.util.measureText(headerText, {
					fontSize: cell.attr("headerText/fontSize")
				});
				// console.log(dim);
				let width = Math.max(dim.width, 90);
				cell.resize(width, height);

				if (cell.get("type") == "rankerx.Project") {
					cell.addModules([
						{
							id: "SocialNetwork",
							// name: "Web 2.0 Blogs",
							// backgroundColor: "#3b5998",
							// textColor: "#f6f6f6",
							checked: false
						},
						{
							id: "WebProfile",
							// name: "Web 2.0 Profile",
							// backgroundColor: "#feb663",
							// textColor: "#222138",
							checked: false
						},
						{
							id: "Bookmarking",
							// name: "Boomarking",
							// backgroundColor: "#b75d32",
							// textColor: "#f6f6f6",
							checked: false
						},
						{
							id: "Wiki",
							// name: "Wiki",
							// backgroundColor: "#dcd7d7",
							// textColor: "#222138",
							checked: false
						},
						{
							id: "ArticleDirectory",
							// name: "Article Directory",
							// backgroundColor: "#eb4924",
							// textColor: "#f6f6f6",
							checked: false
						},
						{
							id: "PDF",
							// name: "PDF",
							// backgroundColor: "#7c68fc",
							// textColor: "#f6f6f6",
							checked: false
						},
						{
							id: "ForumProfile",
							// name: "Forum Profile",
							// backgroundColor: "transparent",
							// textColor: "#222138",
							checked: false
						},
						{
							id: "PressRelease",
							// name: "Press Release",
							// backgroundColor: "#31d0c6",
							// textColor: "#222138",
							checked: false
						}
					]);
				} 

				// cell.resize(100, 54);
				// if (cell.get("type").startsWith("rankerx")) {
				// 	// cell.resize(100, 54);
				// }
				if (opt.stencil) this.createInspector(cell);
			},
			this
		);

		graph.on(
			"remove",
			function(cell, collection, opt) {
				if (cell.get("type").startsWith("rankerx.")) {
					this.releaseProjectNumber(
						cell.get("type"),
						cell.attr("custom/nameId")
					);
					if (this.options.mainPage) {
						this.options.mainPage.removeProject(cell.id);
					}
				}
			},
			this
		);

		this.commandManager = new joint.dia.CommandManager({ graph: graph });

		var paper = (this.paper = new joint.dia.Paper({
			width: 1000,
			height: 1000,
			gridSize: 10,
			drawGrid: false,
			model: graph,
			defaultLink: new joint.shapes.app.Link(),
			defaultConnectionPoint: joint.shapes.app.Link.connectionPoint,
			// interactive: { linkMove: false, vertexMove: false }
			interactive: cellView => {
				if (this.options.viewOnly) {
					if (
						cellView.model.attributes.type &&
						cellView.model.attributes.type.startsWith("rankerx.")
					) {
						return {
							elementMove: false
						};
					}
				}
				return { linkMove: false };
			}
			// interactive: { elementMove: false }
		}));

		paper.options.validateConnection = (cellViewS, magnetS, cellViewT, magnetT, end, linkView) => {			
			let outboundLinks = cellViewS.model.graph.getConnectedLinks(
				cellViewS.model,
				{
					inbound: true
				}
			);
			if (outboundLinks.length == 0) {
				return true;
			} else {
				return false;
			}
		}

		paper.on("blank:mousewheel", _.partial(this.onMousewheel, null), this);
		paper.on("cell:mousewheel", this.onMousewheel, this);

		this.snaplines = new joint.ui.Snaplines({ paper: paper });

		var paperScroller = (this.paperScroller = new joint.ui.PaperScroller({
			paper: paper,
			autoResizePaper: true,
			cursor: "grab"
		}));

		paperScroller.lock();
		paperScroller.setTheme("material");

		this.$(this.options.paperContainerEl).append(paperScroller.el);
		paperScroller.render().center();
	},

	releaseProjectNumber: function(projectType, projectNumber) {
		let numbersUsed = this.projectNumbersUsed[projectType]
			? this.projectNumbersUsed[projectType]
			: [];

		numbersUsed = numbersUsed.filter(number => number != projectNumber);
		this.projectNumbersUsed[projectType] = numbersUsed;
	},

	getFreeProjectNumber: function(projectType) {
		let numbersUsed = this.projectNumbersUsed[projectType]
			? this.projectNumbersUsed[projectType]
			: [];
		numbersUsed.sort((a, b) => {
			return a - b;
		});
		let max = 1;
		for (let i = 0; i < numbersUsed.length; i++) {
			if (i == 0) {
				if (numbersUsed[i] > max) {
					break;
				}
			}
			if (i < numbersUsed.length - 1) {
				if (numbersUsed[i] + 1 != numbersUsed[i + 1]) {
					max = numbersUsed[i] + 1;
					break;
				}
			} else {
				max = numbersUsed[i] + 1;
			}
		}
		numbersUsed.push(max);
		this.projectNumbersUsed[projectType] = numbersUsed;
		console.log(this.projectNumbersUsed[projectType]);
		return max;
	},

	// Create and populate stencil.
	initializeStencil: function() {
		var stencil = (this.stencil = new joint.ui.Stencil({
			paper: this.paperScroller,
			snaplines: this.snaplines,
			scaleClones: true,
			width: 240,
			groups: App.config.stencil.groups,
			dropAnimation: true,
			groupsToggleButtons: false,
			// search: {
			// 	"*": ["type", "attrs/text/text", "attrs/.label/text"],
			// 	"org.Member": ["attrs/.rank/text", "attrs/.name/text"]
			// },
			// Use default Grid Layout
			layout: true,
			// Remove tooltip definition from clone
			dragStartClone: function(cell) {
				return cell.clone().removeAttr("root/dataTooltip");
			}
			// dragEndClone: function(cell) {
			// 	let clone = cell.clone();

			// 	let nameId = this.getFreeProjectNumber(cell.get("type"));

			// 	clone.attr("custom/nameId", nameId);
			// 	let headerText = clone.attr("headerText/text");
			// 	headerText = headerText + ` (${nameId})`;
			// 	clone.attr("headerText/text", headerText);
			// 	clone.attr("custom/projectName", headerText);
			// 	let bbox = clone.getBBox();
			// 	let height = bbox.height;
			// 	let dim = joint.util.measureText(headerText, {
			// 		fontSize: clone.attr("headerText/fontSize")
			// 	});
			// 	console.log(dim);
			// 	let width = Math.max(dim.width, 90);
			// 	clone.resize(width, height);

			// 	if (cell.get("type") == "rankerx.Project") {
			// 		clone.addModules([
			// 			{
			// 				id: "SocialNetwork",
			// 				// name: "Web 2.0 Blogs",
			// 				// backgroundColor: "#3b5998",
			// 				// textColor: "#f6f6f6",
			// 				checked: false
			// 			},
			// 			{
			// 				id: "WebProfile",
			// 				// name: "Web 2.0 Profile",
			// 				// backgroundColor: "#feb663",
			// 				// textColor: "#222138",
			// 				checked: false
			// 			},
			// 			{
			// 				id: "Bookmarking",
			// 				// name: "Boomarking",
			// 				// backgroundColor: "#b75d32",
			// 				// textColor: "#f6f6f6",
			// 				checked: false
			// 			},
			// 			{
			// 				id: "Wiki",
			// 				// name: "Wiki",
			// 				// backgroundColor: "#dcd7d7",
			// 				// textColor: "#222138",
			// 				checked: false
			// 			},
			// 			{
			// 				id: "ArticleDirectory",
			// 				// name: "Article Directory",
			// 				// backgroundColor: "#eb4924",
			// 				// textColor: "#f6f6f6",
			// 				checked: false
			// 			},
			// 			{
			// 				id: "PDF",
			// 				// name: "PDF",
			// 				// backgroundColor: "#7c68fc",
			// 				// textColor: "#f6f6f6",
			// 				checked: false
			// 			},
			// 			{
			// 				id: "ForumProfile",
			// 				// name: "Forum Profile",
			// 				// backgroundColor: "transparent",
			// 				// textColor: "#222138",
			// 				checked: false
			// 			},
			// 			{
			// 				id: "PressRelease",
			// 				// name: "Press Release",
			// 				// backgroundColor: "#31d0c6",
			// 				// textColor: "#222138",
			// 				checked: false
			// 			}
			// 		]);
			// 	}
			// 	return clone;
			// }.bind(this)
		}));

		this.$(".stencil-container").append(stencil.el);
		stencil.setTheme("material");
		stencil.render().load(App.config.stencil.shapes);
	},

	initializeKeyboardShortcuts: function() {
		this.keyboard = new joint.ui.Keyboard();
		this.keyboard.on(
			{
				"ctrl+c": function() {
					// Copy all selected elements and their associated links.
					this.clipboard.copyElements(
						this.selection.collection,
						this.graph
					);
				},

				"ctrl+v": function() {
					var pastedCells = this.clipboard.pasteCells(this.graph, {
						translate: { dx: 20, dy: 20 },
						useLocalStorage: true
					});

					var elements = _.filter(pastedCells, function(cell) {
						return cell.isElement();
					});

					// Make sure pasted elements get selected immediately. This makes the UX better as
					// the user can immediately manipulate the pasted elements.
					this.selection.collection.reset(elements);
				},

				"ctrl+x shift+delete": function() {
					this.clipboard.cutElements(
						this.selection.collection,
						this.graph
					);
				},

				"delete backspace": function(evt) {
					evt.preventDefault();
					this.graph.removeCells(this.selection.collection.toArray());
				},

				"ctrl+z": function() {
					this.commandManager.undo();
					this.selection.cancelSelection();
				},

				"ctrl+y": function() {
					this.commandManager.redo();
					this.selection.cancelSelection();
				},

				"ctrl+a": function() {
					this.selection.collection.reset(this.graph.getElements());
				},

				// "ctrl+plus": function(evt) {
				// 	evt.preventDefault();
				// 	this.paperScroller.zoom(0.2, { max: 5, grid: 0.2 });
				// },

				// "ctrl+minus": function(evt) {
				// 	evt.preventDefault();
				// 	this.paperScroller.zoom(-0.2, { min: 0.2, grid: 0.2 });
				// },

				"keydown:shift": function(evt) {
					this.paperScroller.setCursor("crosshair");
				},

				"keyup:shift": function() {
					this.paperScroller.setCursor("grab");
				}
			},
			this
		);
	},

	initializeSelection: function() {
		this.clipboard = new joint.ui.Clipboard();
		this.selection = new joint.ui.Selection({
			paper: this.paper,
			handles: App.config.selection.handles
		});

		this.selection.addHandle({
			name: "clone",
			position: "se",
			icon: "data:image/svg+xml;charset=utf8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20width%3D%2218.75px%22%20height%3D%2218.75px%22%20viewBox%3D%220%200%2018.75%2018.75%22%20enable-background%3D%22new%200%200%2018.75%2018.75%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%3Cpath%20fill%3D%22%236A6C8A%22%20d%3D%22M12.852%2C0.875h-9.27c-0.853%2C0-1.547%2C0.694-1.547%2C1.547v10.816h1.547V2.422h9.27V0.875z%20M15.172%2C3.965h-8.5%20c-0.849%2C0-1.547%2C0.698-1.547%2C1.547v10.816c0%2C0.849%2C0.698%2C1.547%2C1.547%2C1.547h8.5c0.85%2C0%2C1.543-0.698%2C1.543-1.547V5.512%20C16.715%2C4.663%2C16.021%2C3.965%2C15.172%2C3.965L15.172%2C3.965z%20M15.172%2C16.328h-8.5V5.512h8.5V16.328z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E%20",
			// icon: "data:image/svg+xml;charset=utf-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3Csvg%20width%3D%221792%22%20height%3D%221792%22%20viewBox%3D%220%200%201792%201792%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M888%201184l116-116-152-152-116%20116v56h96v96h56zm440-720q-16-16-33%201l-350%20350q-17%2017-1%2033t33-1l350-350q17-17%201-33zm80%20594v190q0%20119-84.5%20203.5t-203.5%2084.5h-832q-119%200-203.5-84.5t-84.5-203.5v-832q0-119%2084.5-203.5t203.5-84.5h832q63%200%20117%2025%2015%207%2018%2023%203%2017-9%2029l-49%2049q-14%2014-32%208-23-6-45-6h-832q-66%200-113%2047t-47%20113v832q0%2066%2047%20113t113%2047h832q66%200%20113-47t47-113v-126q0-13%209-22l64-64q15-15%2035-7t20%2029zm-96-738l288%20288-672%20672h-288v-288zm444%20132l-92%2092-288-288%2092-92q28-28%2068-28t68%2028l152%20152q28%2028%2028%2068t-28%2068z%22%2F%3E%3C%2Fsvg%3E",
			attrs: {
				".handle": {
					"data-tooltip-class-name": "small",
					"data-tooltip": "Click and drag to clone the selected projects",
					"data-tooltip-position": "left",
					"data-tooltip-padding": 15
				}
			}		
		})

		this.selection.on('action:clone:pointerdown', function(evt,) {
			const graph = this.options.graph;			
			const models = this.model.toArray();
			let pos = this.options.paper.snapToGrid({
                x: evt.clientX,
                y: evt.clientY
			})						

			let selectionBBox = this.options.graph.getBBox(this.model.models);

			let v = {
				x: pos.x - selectionBBox.x,
				y: pos.y - selectionBBox.y
			};			
						
			let modelSet = new Set();			
			let newModelSet = new Set();
			let modelMap = {};

			let newModels = [];			
			this.model.each(elModel => {	
				modelSet.add(elModel.id);

				let newModel = elModel.clone().unset("z");		
				newModel.translate(v.x, v.y);
				newModel.addTo(graph, {
					async: 0
				});									
				newModels.push(newModel);
				modelMap[elModel.id] = newModel.id;				
				newModelSet.add(newModel.id);
			});			


			this.model.each(elModel => {
				let existingLinks = graph.getConnectedLinks(
					elModel,
					{
						inbound: true
					}
				);
				
				if (existingLinks.length > 0) {
					let link = existingLinks[0];
					let source = link.source();
					let target = link.target();
					if (modelSet.has(source.id)) {
						let newSource = {
							id: modelMap[source.id]
						};
						let newTarget = {
							id: modelMap[target.id]
						};
						// console.log("New source", newSource);
						// console.log("New target", newTarget);
						let newLink = new joint.shapes.app.Link(
							{
								source: {
									id: newSource.id
								},
								target: {
									id: newTarget.id
								}
							}
						);
						newLink.addTo(graph, {
							async: 0
						});
					}
				}				
			});

			this.cancelSelection();
			for (let i = 0; i < newModels.length; i++) {
				let elModel = newModels[i];
				this.collection.add(elModel);
			}			

			this.onSelectionBoxPointerDown(evt);
		});


		//We catch this event so we can remove MoneySite from Selection
		this.selection.collection.on("reset add", () => {
			let notRemovableElements = [];
			this.selection.collection.each(item => {
				if (item.get("type") == "rankerx.MoneySite") {
					notRemovableElements.push(item);
				}
			});
			this.selection.collection.remove(notRemovableElements);
		});

		// Initiate selecting when the user grabs the blank area of the paper while the Shift key is pressed.
		// Otherwise, initiate paper pan.
		this.paper.on(
			"blank:pointerdown",
			function(evt, x, y) {
				// this.paper.findViewsInArea(this.paper.getArea()).forEach(cell => {
				// 	cell.unhighlight();
				// });
				if (this.keyboard.isActive("shift", evt)) {
					this.selection.startSelecting(evt);
				} else {
					this.selection.cancelSelection();
					this.paperScroller.startPanning(evt, x, y);
					this.paper.removeTools();
				}
			},
			this
		);

		this.paper.on(
			"element:pointerdown",
			//Start cloning
			function(elementView, evt) {				
				// console.log("Pointer down");
				// Select an element if CTRL/Meta key is pressed while the element is clicked.
				if (this.keyboard.isActive("ctrl meta", evt)) {
					this.selection.collection.add(elementView.model);
				}
			},
			this
		);

		if (this.options.elementPointerClick) {
			this.paper.on(
				"element:pointerclick",
				this.options.elementPointerClick				
			)
		}
		
		this.selection.on(
			"selection-box:pointerdown",
			function(elementView, evt) {
				// Unselect an element if the CTRL/Meta key is pressed while a selected element is clicked.
				if (this.keyboard.isActive("ctrl meta", evt)) {
					this.selection.collection.remove(elementView.model);
				}
			},
			this
		);
	},

	createInspector: function(cell) {
		// return joint.ui.Inspector.create(
		// 	".inspector-container",
		// 	_.extend(
		// 		{
		// 			cell: cell
		// 		},
		// 		App.config.inspector[cell.get("type")]
		// 	)
		// );
	},

	unhighlightAll: function() {		
		this.paper.findViewsInArea(this.paper.getArea()).forEach(cell => {
			cell.unhighlight();
		});
	},

	initializeToolsAndInspector: function() {
		this.paper.on(
			{
				"element:pointerup": function(elementView) {					
					var element = elementView.model;
					if (this.selection.collection.contains(element)) return;

					// new joint.ui.FreeTransform({
					// 	cellView: elementView,
					// 	allowRotation: false,
					// 	preserveAspectRatio: !!element.get("preserveAspectRatio"),
					// 	allowOrthogonalResize:
					// 		element.get("allowOrthogonalResize") !== false
					// }).render();

					if (elementView.model.get("type") != "rankerx.MoneySite") {
						let halo = new joint.ui.Halo({
							cellView: elementView,
							boxContent: false,
							handles: App.config.halo.handles
						});

						// if (
						// 	elementView.model
						// 		.get("type")
						// 		.indexOf("rankerx.Private") == -1
						// ) {
							halo.addHandle({
								name: "myaction",
								position: "s",
								icon:
									"data:image/svg+xml;charset=utf-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3Csvg%20width%3D%221792%22%20height%3D%221792%22%20viewBox%3D%220%200%201792%201792%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M888%201184l116-116-152-152-116%20116v56h96v96h56zm440-720q-16-16-33%201l-350%20350q-17%2017-1%2033t33-1l350-350q17-17%201-33zm80%20594v190q0%20119-84.5%20203.5t-203.5%2084.5h-832q-119%200-203.5-84.5t-84.5-203.5v-832q0-119%2084.5-203.5t203.5-84.5h832q63%200%20117%2025%2015%207%2018%2023%203%2017-9%2029l-49%2049q-14%2014-32%208-23-6-45-6h-832q-66%200-113%2047t-47%20113v832q0%2066%2047%20113t113%2047h832q66%200%20113-47t47-113v-126q0-13%209-22l64-64q15-15%2035-7t20%2029zm-96-738l288%20288-672%20672h-288v-288zm444%20132l-92%2092-288-288%2092-92q28-28%2068-28t68%2028l152%20152q28%2028%2028%2068t-28%2068z%22%2F%3E%3C%2Fsvg%3E",
								attrs: {
									".handle": {
										"data-tooltip-class-name": "small",
										"data-tooltip":
											"Click to set project's account group",
										"data-tooltip-position": "top",
										"data-tooltip-padding": 15
									}
								}
							});

							halo.on("action:myaction:pointerdown", evt => {
								evt.stopPropagation();
								if (
									elementView.model.get("type") !=
									"rankerx.MoneySite"
								) {
									if (this.options.mainPage) {
										this.options.mainPage.showInspector(
											elementView.model
										);
									}
								}
							});

							halo.on("action:link:add", link => {
								var source = link.get('source');
								var target = link.get('target');
								if (!source.id || !target.id) {
									link.remove();
								}

								if (target.id == source.id) {
									link.remove();
									return;
								}

								let tmp = link.get("source");
								link.set("source", link.get("target"));
								link.set("target", tmp);								
							});
						// }

						halo.render();
					}

					this.selection.collection.reset([]);
					this.selection.collection.add(element, { silent: true });

					this.paper.removeTools();

					this.createInspector(element);
					// console.log("Cell clicked");
				},

				"cell:pointerup": function(cellView, evt) {					
					// var cell = cellView.model;
					// if (cell.get("type") === "app.Link") {	
					// 	console.log(evt);					
					// 	let source = cell.get("source");
					// 	let target = cell.get("target");
					// 	if (!target.id || !source.id) {
					// 		cell.remove();
					// 		return;
					// 	}

					// 	if (target.id == source.id) {
					// 		cell.remove();
					// 		return;
					// 	}

					// 	let tmp = cell.get("source");
					// 	cell.set("source", cell.get("target"));
					// 	cell.set("target", tmp);
					// }
				},
				"link:pointerup": function(linkView) {					
					var link = linkView.model;

					var ns = joint.linkTools;
					var toolsView = new joint.dia.ToolsView({
						name: "link-pointerdown",
						tools: [
							// new ns.Vertices(),
							// new ns.SourceAnchor(),
							// new ns.TargetAnchor(),
							// new ns.SourceArrowhead(),
							// new ns.TargetArrowhead(),
							// new ns.Segments(),
							new ns.Boundary({ padding: 15 }),
							new ns.Remove({ offset: -20, distance: 40 })
						]
					});

					this.selection.collection.reset([]);
					this.selection.collection.add(link, { silent: true });

					var paper = this.paper;
					joint.ui.Halo.clear(paper);
					joint.ui.FreeTransform.clear(paper);
					paper.removeTools();

					linkView.addTools(toolsView);

					// this.createInspector(link);
				},

				"link:mouseenter": function(linkView) {
					// Open tool only if there is none yet
					if (linkView.hasTools()) return;

					var ns = joint.linkTools;
					var toolsView = new joint.dia.ToolsView({
						name: "link-hover",
						tools: [
							// new ns.Vertices({ vertexAdding: false }),
							new ns.SourceArrowhead(),
							// new ns.TargetArrowhead()
						]
					});

					linkView.addTools(toolsView);
				},

				"link:mouseleave": function(linkView) {
					// Remove only the hover tool, not the pointerdown tool
					if (linkView.hasTools("link-hover")) {
						linkView.removeTools();
					}
				}
			},
			this
		);

		this.graph.on(
			"change",
			function(cell, opt) {
				if (!cell.isLink() || !opt.inspector) return;

				var ns = joint.linkTools;
				var toolsView = new joint.dia.ToolsView({
					name: "link-inspected",
					tools: [new ns.Boundary({ padding: 15 })]
				});

				cell.findView(this.paper).addTools(toolsView);
			},
			this
		);
	},

	initializeNavigator: function() {
		var navigator = (this.navigator = new joint.ui.Navigator({
			width: 240,
			height: 115,
			paperScroller: this.paperScroller,
			zoom: false,
			paperOptions: {
				elementView: joint.shapes.app.NavigatorElementView,
				linkView: joint.shapes.app.NavigatorLinkView
			}
		}));

		this.$(this.options.navigatorContainerEl).append(navigator.el);
		navigator.setTheme("material");
		navigator.render();
	},

	initializeToolbar: function() {
		var toolbar = (this.toolbar = new joint.ui.Toolbar({
			groups: App.config.toolbar.groups,
			tools: App.config.toolbar.tools,
			references: {
				paperScroller: this.paperScroller,
				commandManager: this.commandManager
			}
		}));

		toolbar.on({
			"json:pointerclick": _.bind(this.saveDiagram, this),
			"svg:pointerclick": _.bind(this.openAsSVG, this),
			"png:pointerclick": _.bind(this.openAsPNG, this),
			"to-front:pointerclick": _.bind(
				this.selection.collection.invoke,
				this.selection.collection,
				"toFront"
			),
			"to-back:pointerclick": _.bind(
				this.selection.collection.invoke,
				this.selection.collection,
				"toBack"
			),
			"layout:pointerclick": _.bind(this.layoutDirectedGraph, this),
			"snapline:change": _.bind(this.changeSnapLines, this),
			"clear:pointerclick": _.bind(this.graph.clear, this.graph),
			"print:pointerclick": _.bind(this.paper.print, this.paper),
			"grid-size:change": _.bind(this.paper.setGridSize, this.paper)
		});

		this.$(".toolbar-container").append(toolbar.el);
		toolbar.render();
	},

	changeSnapLines: function(checked) {
		if (checked) {
			this.snaplines.startListening();
			this.stencil.options.snaplines = this.snaplines;
		} else {
			this.snaplines.stopListening();
			this.stencil.options.snaplines = null;
		}
	},

	initializeTooltips: function() {
		new joint.ui.Tooltip({
			rootTarget: document.body,
			target: "[data-tooltip]",
			direction: "auto",
			padding: 10
		});
	},

	// backwards compatibility for older shapes
	exportStylesheet: ".scalable * { vector-effect: non-scaling-stroke }",

	saveDiagram: function() {
		// console.log(this.graph.toJSON());
	},

	exportDiagram: function() {
		return new Promise(resolve => {
			var paper = this.paper;
			paper.hideTools().toSVG(
				svg => {
					paper.showTools();
					const gl = this.graph.toGraphLib({
						setNodeLabel: function(cell) {
							return cell.get("type");
						}
					});
					// console.log(JSON.stringify(graphlib.json.write(gl)));

					const diagram = this.graph.toJSON();
					const cells = diagram.cells;

					for (let i = 0; i < cells.length; i++) {
						let cell = cells[i];
						let headerText = cell.attrs.headerText;
						let custom = cell.attrs.custom;
						cell.attrs = {
							custom: custom
						};
					}
					resolve({
						svg: svg,
						diagram: diagram
					});
				},
				{
					preserveDimensions: true,
					convertImagesToDataUris: true,
					useComputedStyles: false,
					stylesheet: this.exportStylesheet
				}
			);
		});
		// this.openAsSVG();
		// const gl = this.graph.toGraphLib({
		// 	setNodeLabel: function(cell) {
		// 		return cell.get("type");
		// 	}
		// });
		// console.log(JSON.stringify(graphlib.json.write(gl)));

		// const diagram = this.graph.toJSON();
		// const cells = diagram.cells;

		// for (let i = 0; i < cells.length; i++) {
		// 	let cell = cells[i];
		// 	let headerText = cell.attrs.headerText;
		// 	let custom = cell.attrs.custom;
		// 	cell.attrs = {
		// 		custom: custom
		// 	};
		// }
		// return diagram;
	},

	loadDiagram: function(diagram) {
		this.projectNumbersUsed = {};
		if (diagram.cells) {
			for (let i = 0; i < diagram.cells.length; i++) {
				let cell = diagram.cells[i];
				if (cell.type.startsWith("rankerx.")) {
					if (
						cell.attrs &&
						cell.attrs.headerText &&
						cell.attrs.custom.nameId
					) {
						let numbersUsedByType = this.projectNumbersUsed[
							cell.type
						]
							? this.projectNumbersUsed[cell.type]
							: [];
						numbersUsedByType.push(cell.attrs.custom.nameId);
						this.projectNumbersUsed[cell.type] = numbersUsedByType;
					}
				}
			}
		}
		this.graph.fromJSON(diagram);
	},

	openAsSVG: function() {
		var paper = this.paper;
		paper.hideTools().toSVG(
			function(svg) {
				new joint.ui.Lightbox({
					image: "data:image/svg+xml," + encodeURIComponent(svg),
					downloadable: true,
					fileName: "Rappid"
				}).open();
				paper.showTools();
			},
			{
				preserveDimensions: true,
				convertImagesToDataUris: true,
				useComputedStyles: false,
				stylesheet: this.exportStylesheet
			}
		);
	},

	openAsPNG: function() {
		var paper = this.paper;
		paper.hideTools().toPNG(
			function(dataURL) {
				new joint.ui.Lightbox({
					image: dataURL,
					downloadable: true,
					fileName: "Rappid"
				}).open();
				paper.showTools();
			},
			{
				padding: 10,
				useComputedStyles: false,
				stylesheet: this.exportStylesheet
			}
		);
	},

	onMousewheel: function(cellView, evt, x, y, delta) {
		if (this.keyboard.isActive("alt", evt)) {
			evt.preventDefault();
			this.paperScroller.zoom(delta * 0.2, {
				min: 0.2,
				max: 5,
				grid: 0.2,
				ox: x,
				oy: y
			});
		}
	},

	layoutDirectedGraph: function() {
		joint.layout.DirectedGraph.layout(this.graph, {
			setLinkVertices: true,
			rankDir: "TB",
			marginX: 20,
			marginY: 20
		});
		
		// joint.layout.TreeLayout.layout(this.graph, {
		// 	parentGap: 100,
		// 	siblingGap: 100
		// });

		this.paperScroller.centerContent();
	},

	zoomIn: function() {
		this.paperScroller.zoom(0.2, { max: 5, grid: 0.2 });
	},

	zoomOut: function() {
		this.paperScroller.zoom(-0.2, { max: 5, grid: 0.2 });
	},

	scaleContentToFit: function() {
		this.paper.scaleContentToFit();
	}
});
